<div class="dialog-container">
  <div class="dialog-header">
    <div class="dialog-title-block">
      <h2 mat-dialog-title>{{ data.isEdit ? 'Edit' : 'Add' }} Ratings</h2>
      <p class="dialog-subtitle">
        {{ data.station.name }}
        <span class="meta-sep">·</span>
        {{ data.station.call_sign }} {{ data.station.dial_position }} FM
      </p>
    </div>
    <button mat-icon-button mat-dialog-close class="close-btn" type="button" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="quick-fill-bar">
      <span class="quick-fill-label">Quick fill</span>
      <div class="quick-fill-controls">
        <label class="field-inline">
          <span class="field-caption">Apply to</span>
          <select class="plain-select" [(ngModel)]="selectedDay">
            <option value="ALL">All days</option>
            <option *ngFor="let day of days; let i = index" [value]="day">
              {{ dayLabels[i] }}
            </option>
          </select>
        </label>

        <label class="field-inline">
          <span class="field-caption">Value</span>
          <input
            class="plain-input"
            type="number"
            [(ngModel)]="bulkRating"
            min="0"
            max="10000"
          />
        </label>

        <button type="button" class="apply-btn" (click)="applyBulkRating()">
          Apply
        </button>
      </div>
    </div>

    <div class="ratings-form-wrapper">
      <form [formGroup]="ratingsForm" class="ratings-form">
        <div formArrayName="ratings" class="ratings-grid">
          <div class="grid-header">
            <div class="day-header-cell">Day</div>
            <div
              class="hour-header-cell"
              *ngFor="let hour of hours"
              [attr.title]="getHourDisplay(hour)"
            >
              {{ getHourShort(hour) }}
            </div>
          </div>

          <div class="grid-row" *ngFor="let day of days; let dayIndex = index">
            <div class="day-cell">
              <span class="day-name">{{ dayLabels[dayIndex] }}</span>
            </div>

            <div
              class="rating-input-cell"
              *ngFor="let hour of hours"
              [formGroup]="getRatingControl(day, hour)"
            >
              <input
                class="cell-input"
                type="number"
                formControlName="rating"
                min="0"
                max="10000"
                [attr.aria-label]="dayLabels[dayIndex] + ' ' + getHourDisplay(hour)"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="onSubmit()"
      [disabled]="!ratingsForm.valid"
    >
      {{ data.isEdit ? 'Update Ratings' : 'Add Ratings' }}
    </button>
  </mat-dialog-actions>
</div>
